import { createStore } from '@core'

const visibilityStore = createStore<boolean>(false)

export const openCookieBar = () => visibilityStore.change(true)
export const closeCookieBar = () => visibilityStore.change(false)
export const cookieBarVisibility = {
    value: visibilityStore.value,
    changes: visibilityStore.changes
}

